import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  h: ['75px', null, '95px'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pt: [null, null, '40'],
};

export const TextItem = {
  color: 'white',
  textAlign: 'center',
  fontSize: 'sm',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 'normal',
};

export const LinkItem = {
  color: 'gamma.400',
  fontWeight: 'bold',
};
